import { render, staticRenderFns } from "./WizardLogo.vue?vue&type=template&id=73306b59"
import script from "./WizardLogo.vue?vue&type=script&lang=ts"
export * from "./WizardLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports